import { useContext } from 'react';
import { ServiceIdentifier } from 'inversify';

import { ContainerContext } from '../providers/container/ContainerContext';

/**
 * Hook to get a service from the Inversify DI container
 * @param identifier - The service identifier (usually a Symbol or class)
 * @returns The resolved service instance
 * @throws Error if used outside ContainerProvider
 */
export function useInjection<T>(identifier: ServiceIdentifier<T>): T {
  const container = useContext(ContainerContext);
  if (!container) {
    throw new Error('useInjection must be used within a ContainerProvider');
  }

  return container.get<T>(identifier);
}
